var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(126,211,33)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "translate(0.625122 0.670044)",
    d: "M11.2463 24.955L22.5 24.955C22.5 24.955 22.5 20.765 21.9075 18.9788C21.3913 17.425 17.6625 16.385 13.75 14.91L13.75 11.785C13.75 11.785 15 11.0113 15 8.035C16.25 8.035 16.25 5.535 15 5.535C15 5.2425 16.3475 3.4375 15.9375 1.785C15.345 -0.595 8.24875 -0.595 7.65625 1.785C4.695 1.19 6.25 5.135 6.25 5.535L6.25 8.035C6.25 11.0113 8.75 11.785 8.75 11.785L8.75 14.91C5.2775 16.2288 1.1075 17.425 0.5925 18.9788C0 20.765 0 24.955 0 24.955L11.2463 24.955L11.2463 24.955Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(126,211,33)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "translate(18.2813 0.796997)",
    d: "M7.96875 24.828L11.0938 24.828C11.0938 24.828 11.0938 20.638 10.5013 18.8518C9.985 17.298 6.25625 15.633 2.34375 14.158L2.34375 12.283C2.34375 12.283 3.59375 11.5093 3.59375 8.53302C4.84375 8.53302 4.84375 6.03302 3.59375 6.03302C3.59375 5.74052 4.94125 3.70552 4.53125 2.05302C4.25375 0.940522 1.875 -0.819478 0 0.430522"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroup);
export default __webpack_public_path__ + "static/media/icon_group.572e712495c2522d6478648059a06e41.svg";
export { ForwardRef as ReactComponent };